export default 'https://tme.understood.org/assets/Light_Texture02.f4e2b7a9.jpg'